import {useState} from 'react';
import { Link } from 'react-router-dom';
import { FRONTEND_LOGIN_URL } from '../../Utils/Constants';
import lykio_logo from '../../multimedia/lykio_logo_transparent.png';
import Form from 'react-bootstrap/Form';
import Accordion from 'react-bootstrap/Accordion';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Table from 'react-bootstrap/Table';
import t from "../../Utils/Translation";

const API = () => {
    const [key, setKey] = useState('token');

	return (
		<div className="lykiocss-screen-center lykiocss-generic-background">
            <Form className="LykioForm lykiocss-white-background lykiocss-login-form-border lykiocss-form-size">
            <Link to={FRONTEND_LOGIN_URL}>
					<div className="lykiocss-center">
						<img className="lykiocss-small-login-logo" src={lykio_logo} alt="" />
					</div>
			</Link>
			<h3 className="lykiocss-center">{t("API Documentation")}</h3>
            <Tabs defaultActiveKey="profile" 
            id="uncontrolled-tab-example" 
            activeKey={key}
            onSelect={(k) => setKey(k)} 
            className="mb-3">
            <Tab eventKey="token" title="Get Token">
            <Accordion defaultActiveKey="0" flush>
                <Accordion.Item eventKey="0">
                    <Accordion.Header>Get Token</Accordion.Header>
                    <Accordion.Body>
                    <p>
                    This is a POST call performed at <i><b>{`{BASE_URL}`}/api/auth/token</b></i> <br/>
                    where BASE_URL is the hosting website's domain e.g. "https://dev.lykio.com"
                    </p>
                    <p>
                    The required body is a JSON object with the following properties<br/>
                    <code>{
                    `{
                        "username":"somebody@email.com"
                        "password":"whatever123"
                     }`    
                    }</code>
                    </p>
                    <p>
                    The response is an object containing the access_token property<br/>
                    <code>{
                    `{
                        "access_token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjYxZDdmODN"
                     }`    
                    }</code>
                    </p>
                    </Accordion.Body>
                </Accordion.Item>    
            </Accordion>
            </Tab>
            <Tab eventKey="details" title="User Details">
            <Accordion defaultActiveKey="1" flush>
                <Accordion.Item eventKey="1">
                    <Accordion.Header>Get User Details</Accordion.Header>
                    <Accordion.Body>
                    <p>
                This is a GET call performed at <i><b>{`{BASE_URL}`}/api/private/user/details</b></i> <br/>
                where BASE_URL is the hosting website's domain e.g. "https://dev.lykio.com"
                </p>
                <p>
                The required Headers should include the following <br/>
                <Table striped bordered hover>
                <tbody>
                    <tr>
                    <td>Accept</td>
                    <td>application/json</td>
                    </tr>
                    <tr>
                    <td>Authorization</td>
                    <td>Bearer {`{access_token}`}</td>
                    </tr>
                </tbody>
                </Table>
                </p>
                <p>
                The response is an object containing the following<br/>
                <code>{
                `{
                    "userDetails": {
                      "username": "user1@mailinator.com",
                      "firstName": "Manos",
                      "lastName": "Porter Jr",
                      "tenantId": "61d7f6ad9ab097143f12d029",
                      "id": "61d7f83b9ab097143f12d245",
                      "accountNonExpired": true,
                      "accountNonLocked": true,
                      "credentialsNonExpired": true,
                      "enabled": true
                    }
                  }
                `    
                }</code>
                </p>
                    </Accordion.Body>
                </Accordion.Item>    
            </Accordion>
            </Tab>
            <Tab eventKey="data" title="User Data">
            <Accordion defaultActiveKey="1" flush>
                <Accordion.Item eventKey="1">
                <Accordion.Header>Get User Data</Accordion.Header>
                <Accordion.Body>
                <p>
                This is a GET call performed at <i><b>{`{BASE_URL}`}/api/private/user/getData</b></i> <br/>
                where BASE_URL is the hosting website's domain e.g. "https://dev.lykio.com"
                </p>
                <p>
                The required Headers should include the following <br/>
                <Table striped bordered hover>
                <tbody>
                    <tr>
                    <td>Accept</td>
                    <td>application/json</td>
                    </tr>
                    <tr>
                    <td>Authorization</td>
                    <td>Bearer {`{access_token}`}</td>
                    </tr>
                </tbody>
                </Table>
                </p>
                <p>
                The response is an object containing the following<br/>
                <code>{
                `{
                    "userId": "61d7f83b9ab097143f12d245",
                    "userDataType": "JSON",
                    "data": {
                      "userSaveJson": {
                        "score": 35,
                        "finalScore": 35,
                        "gameStatus": "completed",
                        "gameResult": "pass",
                        "showIntro": true,
                        "mentor": "mentor2",
                        "avatarId": 4
                      }
                    }
                  }
                `    
                }</code>
                </p>
                    </Accordion.Body>
                </Accordion.Item>    
            </Accordion>

            <Accordion defaultActiveKey="1" flush>
                <Accordion.Item eventKey="2">
                    <Accordion.Header>Save User Data</Accordion.Header>
                    <Accordion.Body>
                    <p>
                This is a POST call performed at <i><b>{`{BASE_URL}`}/api/private/user/saveData</b></i> <br/>
                where BASE_URL is the hosting website's domain e.g. "https://dev.lykio.com"
                </p>
                <p>
                The required Headers should include the following <br/>
                <Table striped bordered hover>
                <tbody>
                    <tr>
                    <td>Accept</td>
                    <td>application/json</td>
                    </tr>
                    <tr>
                    <td>Authorization</td>
                    <td>Bearer {`{access_token}`}</td>
                    </tr>
                </tbody>
                </Table>
                <p>
                The required body is a JSON object with the following properties<br/>
                    <code>{
                    `{
                        "userSaveJson": {
                            "score": 35,
                            "finalScore": 35,
                            "gameStatus": "completed",
                            "gameResult": "pass",
                            "showIntro": true,
                            "mentor": "mentor2",
                            "avatarId": 4
                        }
                      }`    
                    }</code>
                </p>
                
                </p>
                <p>
                The response is an object containing the following (which contains the userSaveJson that was just updated)<br/>
                <code>{
                `{
                    "userId": "61d7f83b9ab097143f12d245",
                    "userDataType": "JSON",
                    "data": {
                      "userSaveJson": {
                        "score": 35,
                        "finalScore": 35,
                        "gameStatus": "completed",
                        "gameResult": "pass",
                        "showIntro": true,
                        "mentor": "mentor2",
                        "avatarId": 4
                      }
                    }
                  }`    
                }</code>
                </p>
                    </Accordion.Body>
                </Accordion.Item>    
            </Accordion>
            </Tab>
            <Tab eventKey="progressdata" title="Progress Data">
            <Accordion defaultActiveKey="1" flush>
                <Accordion.Item eventKey="1">
                    <Accordion.Header>Get Progress Data</Accordion.Header>
                    <Accordion.Body>
                    <p>
                This is a GET call performed at <i><b>{`{BASE_URL}`}/api/private/user/getProgressData</b></i> <br/>
                where BASE_URL is the hosting website's domain e.g. "https://dev.lykio.com"
                </p>
                <p>
                The required Headers should include the following <br/>
                <Table striped bordered hover>
                <tbody>
                    <tr>
                    <td>Accept</td>
                    <td>application/json</td>
                    </tr>
                    <tr>
                    <td>Authorization</td>
                    <td>Bearer {`{access_token}`}</td>
                    </tr>
                </tbody>
                </Table>
                </p>
                <p>
                The response is an object containing the following<br/>
                <code>{
                `{
                    "progressData": {
                      "currentNodeId": 0,
                      "userId": "asdfasfawrf315tw4g",
                      "nodes": [
                        {
                          "nodeId": 101,
                          "nodeState": "completed",
                          "bonusType": "bronze",
                          "lessons": [
                            {
                              "lessonId": 10101,
                              "gameState": "completed",
                              "stars": 2
                            },
                            {
                              "lessonId": 10102,
                              "gameState": "completed",
                              "stars": 4
                            },
                            {
                              "lessonId": 10103,
                              "gameState": "unlock",
                              "stars": 10
                            }
                          ]
                        },
                        {
                          "nodeId": 102,
                          "nodeState": "unlock",
                          "bonusType": null,
                          "lessons": [
                            {
                              "lessonId": 10201,
                              "gameState": "unlock",
                              "stars": 0
                            },
                            {
                              "lessonId": 10202,
                              "gameState": "unlock",
                              "stars": 0
                            },
                            {
                              "lessonId": 10203,
                              "gameState": "unlock",
                              "stars": 0
                            }
                          ]
                        },
                        {
                          "nodeId": 103,
                          "nodeState": "unlock",
                          "bonusType": null,
                          "lessons": [
                            {
                              "lessonId": 10301,
                              "gameState": "unlock",
                              "stars": 0
                            },
                            {
                              "lessonId": 10302,
                              "gameState": "unlock",
                              "stars": 0
                            },
                            {
                              "lessonId": 10303,
                              "gameState": "unlock",
                              "stars": 0
                            }
                          ]
                        }
                      ]
                    }
                  }
                `    
                }</code>
                </p>
                    </Accordion.Body>
                </Accordion.Item>    
            </Accordion>

            <Accordion defaultActiveKey="1" flush>
                <Accordion.Item eventKey="2">
                    <Accordion.Header>Save Progress Data</Accordion.Header>
                    <Accordion.Body>
                    <p>
                This is a POST call performed at <i><b>{`{BASE_URL}`}/api/private/user/saveProgressData</b></i> <br/>
                where BASE_URL is the hosting website's domain e.g. "https://dev.lykio.com"
                </p>
                <p>
                The required Headers should include the following <br/>
                <Table striped bordered hover>
                <tbody>
                    <tr>
                    <td>Accept</td>
                    <td>application/json</td>
                    </tr>
                    <tr>
                    <td>Authorization</td>
                    <td>Bearer {`{access_token}`}</td>
                    </tr>
                </tbody>
                </Table>
                <p>
                The required body is a JSON object with the following properties<br/>
                    <code>{
                    `{
                        "progressData": {
                          "currentNodeId": 0,
                          "userId": "asdfasfawrf315tw4g",
                          "nodes": [
                            {
                              "nodeId": 101,
                              "nodeState": "completed",
                              "bonusType": "bronze",
                              "lessons": [
                                {
                                  "lessonId": 10101,
                                  "gameState": "completed",
                                  "stars": 2
                                },
                                {
                                  "lessonId": 10102,
                                  "gameState": "completed",
                                  "stars": 4
                                },
                                {
                                  "lessonId": 10103,
                                  "gameState": "unlock",
                                  "stars": 10
                                }
                              ]
                            },
                            {
                              "nodeId": 102,
                              "nodeState": "unlock",
                              "bonusType": null,
                              "lessons": [
                                {
                                  "lessonId": 10201,
                                  "gameState": "unlock",
                                  "stars": 0
                                },
                                {
                                  "lessonId": 10202,
                                  "gameState": "unlock",
                                  "stars": 0
                                },
                                {
                                  "lessonId": 10203,
                                  "gameState": "unlock",
                                  "stars": 0
                                }
                              ]
                            },
                            {
                              "nodeId": 103,
                              "nodeState": "unlock",
                              "bonusType": null,
                              "lessons": [
                                {
                                  "lessonId": 10301,
                                  "gameState": "unlock",
                                  "stars": 0
                                },
                                {
                                  "lessonId": 10302,
                                  "gameState": "unlock",
                                  "stars": 0
                                },
                                {
                                  "lessonId": 10303,
                                  "gameState": "unlock",
                                  "stars": 0
                                }
                              ]
                            }
                          ]
                        }
                      }`    
                    }</code>
                </p>
                
                </p>
                <p>
                The response is an object containing the following (the progress data that was just updated)<br/>
                <code>{
                `{
                    "progressData": {
                      "currentNodeId": 0,
                      "userId": "asdfasfawrf315tw4g",
                      "nodes": [
                        {
                          "nodeId": 101,
                          "nodeState": "completed",
                          "bonusType": "bronze",
                          "lessons": [
                            {
                              "lessonId": 10101,
                              "gameState": "completed",
                              "stars": 2
                            },
                            {
                              "lessonId": 10102,
                              "gameState": "completed",
                              "stars": 4
                            },
                            {
                              "lessonId": 10103,
                              "gameState": "unlock",
                              "stars": 10
                            }
                          ]
                        },
                        {
                          "nodeId": 102,
                          "nodeState": "unlock",
                          "bonusType": null,
                          "lessons": [
                            {
                              "lessonId": 10201,
                              "gameState": "unlock",
                              "stars": 0
                            },
                            {
                              "lessonId": 10202,
                              "gameState": "unlock",
                              "stars": 0
                            },
                            {
                              "lessonId": 10203,
                              "gameState": "unlock",
                              "stars": 0
                            }
                          ]
                        },
                        {
                          "nodeId": 103,
                          "nodeState": "unlock",
                          "bonusType": null,
                          "lessons": [
                            {
                              "lessonId": 10301,
                              "gameState": "unlock",
                              "stars": 0
                            },
                            {
                              "lessonId": 10302,
                              "gameState": "unlock",
                              "stars": 0
                            },
                            {
                              "lessonId": 10303,
                              "gameState": "unlock",
                              "stars": 0
                            }
                          ]
                        }
                      ]
                    }
                  }`    
                }</code>
                </p>
                    </Accordion.Body>
                </Accordion.Item>    
            </Accordion>
            </Tab>
            <Tab eventKey="leaderboards" title="Leaderboards">
            <Accordion defaultActiveKey="1" flush>
                <Accordion.Item eventKey="1">
                    <Accordion.Header>Get User Details</Accordion.Header>
                    <Accordion.Body>
                    <p>
                This is a GET call performed at <i><b>{`{BASE_URL}`}/api/private/user/getLeaderBoard</b></i> <br/>
                where BASE_URL is the hosting website's domain e.g. "https://dev.lykio.com"
                </p>
                <p>
                The required Headers should include the following <br/>
                <Table striped bordered hover>
                <tbody>
                    <tr>
                    <td>Accept</td>
                    <td>application/json</td>
                    </tr>
                    <tr>
                    <td>Authorization</td>
                    <td>Bearer {`{access_token}`}</td>
                    </tr>
                </tbody>
                </Table>
                </p>
                <p>
                The response is an object containing the following<br/>
                <code>{
                `{
                    "leaderboardData": {
                      "users": [
                        {
                          "username": "user1@mailinator.com",
                          "finalScore": 35,
                          "avatarId": 4
                        },
                        {
                          "username": "user2@mailinator.com",
                          "finalScore": 30,
                          "avatarId": 4
                        },
                        {
                          "username": "dev@mailinator.com",
                          "finalScore": 25,
                          "avatarId": 4
                        }
                      ]
                    }
                  }
                `    
                }</code>
                </p>
                    </Accordion.Body>
                </Accordion.Item>    
            </Accordion>
            </Tab>
            </Tabs>
            </Form>
		</div>
	);
};

export default API;
